import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const agentWebsiteApi = createApi({
  reducerPath: "agentWebsiteApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["AgentWebsite"],
  endpoints: (builder) => ({
    getMyWebsite: builder.query({
      query: () => "/agent-website",
      providesTags: ["AgentWebsite"],
    }),
    updateMyWebsite: builder.mutation({
      query: (data) => ({ url: "/agent-website", method: "PUT", body: data }),
      invalidatesTags: ["AgentWebsite"],
    }),
    getWebsiteAnalytics: builder.query({
      query: () => "/agent-website/analytics",
    }),
    addLandingPage: builder.mutation({
      query: (data) => ({ url: "/agent-website/landing-pages", method: "POST", body: data }),
      invalidatesTags: ["AgentWebsite"],
    }),
    updateLandingPage: builder.mutation({
      query: ({ pageId, ...data }) => ({ url: `/agent-website/landing-pages/${pageId}`, method: "PUT", body: data }),
      invalidatesTags: ["AgentWebsite"],
    }),
    deleteLandingPage: builder.mutation({
      query: (pageId) => ({ url: `/agent-website/landing-pages/${pageId}`, method: "DELETE" }),
      invalidatesTags: ["AgentWebsite"],
    }),
    addTestimonial: builder.mutation({
      query: (data) => ({ url: "/agent-website/testimonials", method: "POST", body: data }),
      invalidatesTags: ["AgentWebsite"],
    }),
    deleteTestimonial: builder.mutation({
      query: (id) => ({ url: `/agent-website/testimonials/${id}`, method: "DELETE" }),
      invalidatesTags: ["AgentWebsite"],
    }),
  }),
});

export const {
  useGetMyWebsiteQuery,
  useUpdateMyWebsiteMutation,
  useGetWebsiteAnalyticsQuery,
  useAddLandingPageMutation,
  useUpdateLandingPageMutation,
  useDeleteLandingPageMutation,
  useAddTestimonialMutation,
  useDeleteTestimonialMutation,
} = agentWebsiteApi;
